import { useEffect, useState } from 'react';

// Peças comuns ao Diário (AgendaDayList) e à Semana (AgendaWeek)

// Redesenha a cada virada de minuto, só enquanto ligado (hoje na tela) e com a aba visível: a linha "agora" anda sozinha
export function useMinuteTick(enabled) {
  const [, setTick] = useState(0);

  useEffect(() => {
    if (!enabled) return undefined;

    let timer = null;
    const schedule = () => {
      clearTimeout(timer);
      if (document.visibilityState === 'hidden') return;
      const current = new Date();
      timer = setTimeout(() => {
        setTick((tick) => tick + 1);
        schedule();
      }, 60000 - (current.getSeconds() * 1000 + current.getMilliseconds()));
    };
    const onVisibility = () => {
      if (document.visibilityState !== 'hidden') setTick((tick) => tick + 1);
      schedule();
    };

    schedule();
    document.addEventListener('visibilitychange', onVisibility);
    return () => {
      clearTimeout(timer);
      document.removeEventListener('visibilitychange', onVisibility);
    };
  }, [enabled]);
}

// Rola a página de uma vez, sem animação (o Bootstrap liga a rolagem suave da página)
export function scrollPageTo(top) {
  const root = document.documentElement;
  const previous = root.style.scrollBehavior;
  root.style.scrollBehavior = 'auto';
  window.scrollTo(0, Math.max(0, Math.round(top)));
  root.style.scrollBehavior = previous;
}
